<div class="drawer-layout" id="shared-modal-container">
  <div class="drawer-layout-header-wrapper" id="shared-drawer-layout-container">
    <div class="icon" id="shared-icon-wrapper">
      <app-icon
        *ngIf="!customizeCloseIcon; else customizedCloseIcon"
        [color]="''"
        [name]="'close'"
        [size]="'1rem'"
        mat-dialog-close=""
        id="shared-icon-content"
        class="modal-close-icon"
      ></app-icon>

      <!-- CUSTOMIZED CLOSE ICON -->
      <ng-template #customizedCloseIcon>
        <app-icon
          [name]="'close'"
          [size]="'1rem'"
          id="shared-icon-content-customized"
          class="modal-close-icon"
          (click)="onCloseIconClick()"
        ></app-icon>
      </ng-template>
    </div>
  </div>
  <div class="drawer-layout-content-wrapper" id="shared-drawer-container">
    <ng-content select=".drawer-layout-content"></ng-content>
  </div>
  <div
    class="drawer-layout-footer-wrapper"
    *ngIf="isFooterPresent"
    id="shared-footer-wrapper"
  >
    <ng-content select=".drawer-layout-footer"></ng-content>
  </div>
</div>
